import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Text, Box, Flex } from '@chakra-ui/react';
import { formatCurrency, formatPrice } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SkeletonBox = _ref => {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? '50%' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '20px' : _ref$height,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? '4px' : _ref$borderRadius;
  return _jsx(Box, {
    "data-testid": "skeleton-box",
    width: width,
    height: height,
    borderRadius: borderRadius,
    bg: "#EEEEEE",
    position: "relative",
    overflow: "hidden",
    margin: '0 auto',
    _before: {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-100%',
      width: '100%',
      height: '100%',
      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)',
      animation: 'shimmer 1.8s infinite ease-in-out'
    },
    sx: {
      '@keyframes shimmer': {
        '0%': {
          left: '-100%'
        },
        '50%': {
          left: '100%'
        },
        '100%': {
          left: '100%'
        }
      }
    }
  });
};
var MonthTab = _ref2 => {
  var language = _ref2.language,
    label = _ref2.label,
    price = _ref2.price,
    isActive = _ref2.isActive,
    currencySymbol = _ref2.currencySymbol,
    onClick = _ref2.onClick,
    isLoading = _ref2.isLoading,
    isLowestPriceInMonthTabEnabled = _ref2.isLowestPriceInMonthTabEnabled,
    badgeColor = _ref2.badgeColor;
  var _styles = styles(isActive, label, badgeColor),
    container = _styles.container,
    badge = _styles.badge,
    bottomHighlight = _styles.bottomHighlight,
    priceWrapper = _styles.priceWrapper,
    labelText = _styles.labelText;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var fromLowestPrice = formatPrice(formatCurrency(currencySymbol), price, language);
  return _jsxs(Flex, _objectSpread(_objectSpread({}, container), {}, {
    onClick: onClick,
    "data-testid": "month-tab-".concat(label),
    children: [_jsx(Text, _objectSpread(_objectSpread({}, labelText), {}, {
      children: label
    })), isLowestPriceInMonthTabEnabled && (isLoading && isActive ? _jsx(SkeletonBox, {}) : !!price && isActive && _jsxs(Box, _objectSpread(_objectSpread({}, priceWrapper), {}, {
      children: [_jsx(Text, {
        as: "span",
        children: t('priceFinder.from')
      }), _jsx(Text, _objectSpread(_objectSpread({}, badge), {}, {
        children: fromLowestPrice
      }))]
    }))), isActive && _jsx(Box, _objectSpread({}, bottomHighlight))]
  }));
};
export default MonthTab;
var styles = (isActive, label, badgeColor) => ({
  container: {
    _first: {
      ml: {
        mobile: 0,
        sm: 2
      },
      mr: {
        mobile: 2
      }
    },
    as: 'button',
    direction: 'column',
    align: 'center',
    justify: 'center',
    width: {
      base: '117px',
      sm: '145px'
    },
    height: {
      base: isActive ? '57px' : '48px',
      sm: isActive ? '72px' : '50px'
    },
    flexShrink: 0,
    mx: 2,
    position: 'relative',
    bg: isActive ? 'white' : '#e9f2f3',
    color: isActive ? '#02798d' : 'gray.700',
    border: '1px solid #c4cacb',
    borderBottom: isActive ? 'none' : '1px solid #c4cacb',
    borderTopLeftRadius: 'md',
    borderTopRightRadius: 'md',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '0',
    zIndex: isActive ? 1 : 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: 'md',
    'data-month-value': label,
    _hover: isActive ? {
      bg: 'white',
      cursor: 'pointer',
      zIndex: 2
    } : {
      bg: 'white',
      color: '#02798d',
      cursor: 'pointer',
      height: '57px',
      transition: 'height 0.2s'
    }
  },
  labelText: {
    fontWeight: isActive ? 'bold' : 'medium'
  },
  priceWrapper: {
    mt: 1,
    fontSize: 'xs',
    color: 'var(--chakra-colors-darkGrey1)'
  },
  badge: {
    as: 'span',
    bg: badgeColor || '#fdb913',
    color: '#333333',
    px: 2,
    py: 0.5,
    ml: 1,
    fontWeight: '500',
    lineHeight: '20px',
    borderRadius: 'sm',
    display: 'inline-block',
    fontSize: '13px',
    padding: '0 2px',
    h: '19px'
  },
  bottomHighlight: {
    position: 'absolute',
    bottom: '-1px',
    left: 0,
    right: 0,
    height: '2px',
    bg: 'white',
    zIndex: -1,
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px'
  }
});